<template>
  <div class="h-link-space">
    <h1 class="title1">友情链接</h1>
    <div class="member-module-cup">
      <div class="member-module">
        <el-row :gutter="20">
          <el-col :span="4" v-for="itemM in memberDisplay" :key="itemM.index">
            <el-link :href="itemM.commonUrl" :underline="false" target="_blank" class="memberItem">
              <img :src="itemM.commonImg" :alt="itemM.commonName" height="67" width="200">
            </el-link>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { homeCommonData } from '@/api/frontApi/frontHome';
export default {
  data() {
    return {
      memberDisplay1: [],
      memberDisplay2: [],
      memberDisplay: []
    };
  },
  components: {},
  created() {
    this.getHomeLink();
  },
  methods: {
    getHomeLink() {
      homeCommonData({ pageNo: 1, pageSize: 100, commonType: 3 }).then(res => {
        this.memberDisplay = res.data.records;
        // let memberDisplay = this.arrGroup(res.data.records, 5);
        // this.memberDisplay1 = memberDisplay[0];
        // this.memberDisplay2 = memberDisplay[1];
      });
    },
    arrGroup(arr, subPoint) {
      let index = 0;
      let newArr = [];
      while (index < arr.length) {
        newArr.push(arr.slice(index, (index += subPoint)));
      }
      return newArr;
    }
  }
};
</script>
<style scoped>
.h-link-space {
  background-color: #fff;
  padding: 10px 0;
}
.member-module-cup {
  text-align: center;
  margin: 0 auto;
  width: 100%;
}
.member-module {
  width: 70%;
  margin: 0 auto;
}
.memberItem {
  cursor: pointer;
  margin: 10px auto;
}
.title1 {
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/homeLink.vue